var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCitt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36.2 32.8",
    style: {
      enableBackground: "new 0 0 36.2 32.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Sede",
    transform: "translate(-5.289 -4.779)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_399",
    style: {
      fill: "none",
      stroke: "#005BA9",
      strokeMiterlimit: 10
    },
    cx: 32.2,
    cy: 14.1,
    rx: 3.4,
    ry: 3.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20388",
    style: {
      fill: "none",
      stroke: "#005BA9",
      strokeMiterlimit: 10
    },
    d: "M20,37.1v-1.9c0-0.5,0.4-1,1-1c0,0,0,0,0,0h16.2 c0.5,0,1,0.4,1,1l0,0v1.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20389",
    style: {
      fill: "none",
      stroke: "#005BA9",
      strokeMiterlimit: 10
    },
    d: "M8.6,37.1V6.5c0-0.7,0.6-1.2,1.2-1.2l0,0h13.5 c0.7,0,1.2,0.6,1.2,1.2v15.7c0,0.7-0.6,1.2-1.2,1.2h-4c-0.7,0-1.2,0.6-1.2,1.2v12.4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8608",
    x: 13.1,
    y: 9.4,
    style: {
      fill: "none",
      stroke: "#005BA9",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 1.9,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8609",
    x: 18.1,
    y: 9.4,
    style: {
      fill: "none",
      stroke: "#005BA9",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 1.9,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8610",
    x: 13.1,
    y: 16.4,
    style: {
      fill: "none",
      stroke: "#005BA9",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 1.9,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8611",
    x: 18.1,
    y: 16.4,
    style: {
      fill: "none",
      stroke: "#005BA9",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 1.9,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8612",
    x: 13.2,
    y: 30.5,
    style: {
      fill: "none",
      stroke: "#005BA9",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 1.9,
    height: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20391",
    style: {
      fill: "none",
      stroke: "#005BA9",
      strokeMiterlimit: 10
    },
    d: "M33.6,22c1.1-1.7,2.2-3.3,3.3-5 c1.6-2.6,0.7-5.9-1.8-7.5c-1.1-0.7-2.4-0.9-3.7-0.7c-3,0.5-5,3.3-4.6,6.3c0.1,0.8,0.4,1.5,0.8,2.1c0.9,1.3,1.7,2.6,2.6,3.9l0.6,1 l0.5,0.8c0.3,0.4,0.9,0.6,1.3,0.3c0.1-0.1,0.2-0.2,0.3-0.3L33.6,22z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_8613",
    style: {
      fill: "none",
      stroke: "#005BA9",
      strokeMiterlimit: 10
    },
    d: "M21,25.4h16.1c0.6,0,1,0.4,1,1v0.8 c0,0.6-0.4,1-1,1H21c-0.6,0-1-0.4-1-1v-0.8C20,25.9,20.5,25.4,21,25.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20392",
    style: {
      fill: "none",
      stroke: "#005BA9",
      strokeMiterlimit: 10
    },
    d: "M20,31.3L20,31.3c0-0.5,0.4-1,1-1c0,0,0,0,0,0 h16.2c0.5,0,1,0.4,1,1s-0.4,1-1,1H21C20.5,32.2,20,31.8,20,31.3C20,31.3,20,31.3,20,31.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20393",
    style: {
      fill: "none",
      stroke: "#005BA9",
      strokeLinecap: "round"
    },
    d: "M5.8,37.1H41"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8614",
    x: 13.1,
    y: 23.4,
    style: {
      fill: "none",
      stroke: "#005BA9",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 1.9,
    height: 3.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCitt);
export default __webpack_public_path__ + "static/media/Citt.0d53966fb79c98d14d04ae38886257d6.svg";
export { ForwardRef as ReactComponent };